import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { INotification } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'
import { selectProducts } from '../../selectors/productsSelectors'

export const fetchNotifications = createAsyncThunk<
    { hasMore: boolean; notifications: INotification[] } | void,
    { productIds?: string[] },
    ThunkConfig<string>
>('notificationsSlice/fetchNotifications', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        getState,
    } = thunkAPI

    const products = selectProducts(getState())
    const isFetchAll = products?.length === args.productIds?.length || args.productIds?.length === 0
    const productIds = isFetchAll ? null : args.productIds

    try {
        const { data } = await api.post<{
            notifications: INotification[]
            has_more: boolean
        }>(getUrlWithVersion(`/notifications`), { product_ids: productIds })

        if (
            typeof data?.has_more !== 'boolean' ||
            !Array.isArray(data?.notifications)
        ) {
            const error = new Error('Received notifications in wrong format')
            console.error(error.message)
            return
        }

        return { hasMore: data.has_more, notifications: data.notifications }
    } catch (e) {
        console.error(e)
        return rejectWithValue('Failed to fetch notifications')
    }
})
